import { render, staticRenderFns } from "./AddEditRemoteConnectionScreen.vue?vue&type=template&id=087f98ea&scoped=true"
import script from "./AddEditRemoteConnectionScreen.vue?vue&type=script&lang=js"
export * from "./AddEditRemoteConnectionScreen.vue?vue&type=script&lang=js"
import style0 from "./AddEditRemoteConnectionScreen.vue?vue&type=style&index=0&id=087f98ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087f98ea",
  null
  
)

export default component.exports